var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-highcharts',{ref:"chartObservations",attrs:{"options":_vm.obj_chart.observationsOption}})}
var staticRenderFns = []

export { render, staticRenderFns }